/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './intra-op-investigation.reducer';

export const IntraOPInvestigationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const intraOPInvestigationEntity = useAppSelector(state => state.intraOPInvestigation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="intraOPInvestigationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.detail.title">IntraOPInvestigation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.id">Id</Translate>
            </span>
          </dt>
          <dd>{intraOPInvestigationEntity.id}</dd>
          <dt>
            <span id="orderedBy">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.orderedBy">Ordered By</Translate>
            </span>
            <UncontrolledTooltip target="orderedBy">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.orderedBy" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.orderedBy}</dd>
          <dt>
            <span id="orderedById">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.orderedById">Ordered By Id</Translate>
            </span>
            <UncontrolledTooltip target="orderedById">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.orderedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.orderedById}</dd>
          <dt>
            <span id="serviceType">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.serviceType">Service Type</Translate>
            </span>
          </dt>
          <dd>{intraOPInvestigationEntity.serviceType}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{intraOPInvestigationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.surgery">Surgery</Translate>
          </dt>
          <dd>{intraOPInvestigationEntity.surgery ? intraOPInvestigationEntity.surgery.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.labPrescription">Lab Prescription</Translate>
          </dt>
          <dd>{intraOPInvestigationEntity.labPrescription ? intraOPInvestigationEntity.labPrescription.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.intraOPInvestigation.radiologyStudy">Radiology Study</Translate>
          </dt>
          <dd>{intraOPInvestigationEntity.radiologyStudy ? intraOPInvestigationEntity.radiologyStudy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/intra-op-investigation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/intra-op-investigation/${intraOPInvestigationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default IntraOPInvestigationDetail;
